import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.css'],
})
export class ModalConfirmationComponent {

  @ViewChild('modal') private modal: any; // tslint:disable-line:no-any
  @Input() public titleText: string;
  @Input() public contentText: string;
  @Output() private confirm: EventEmitter<any> = new EventEmitter(); // tslint:disable-line:no-any
  @Output() private cancel: EventEmitter<any> = new EventEmitter(); // tslint:disable-line:no-any
  private eventData: any; // tslint:disable-line:no-any

  constructor() {
    this.titleText = '';
    this.contentText = 'Sind Sie sicher?';
  }

  public show(): ModalConfirmationComponent {
    this.modal.show();
    return this;
  }

  public hide(): ModalConfirmationComponent {
    this.modal.hide();
    return this;
  }

  public setEventData(data: any): ModalConfirmationComponent { // tslint:disable-line:no-any
    this.eventData = data;
    return this;
  }

  public setTitle(title: string): ModalConfirmationComponent {
    this.titleText = title;
    return this;
  }

  public setContent(content: string): ModalConfirmationComponent {
    this.contentText = content;
    return this;
  }

  public doConfirm(): void {
    this.hide();
    this.confirm.emit(this.eventData);
  }

  public doCancel(): void {
    this.hide();
    this.cancel.emit(this.eventData);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/modals/modal-confirmation/modal-confirmation.component.ts